











































































































































import { Vue, Component, Lifecycle, Watch } from "av-ts";
import { IUserSummary, IOfferingUser } from "../../interfaces/models";
import DatePicker from "vue-flatpickr-component";
import UserService from "../../services/UserService";
import Fetcher from "../../services/Fetcher";
import { isAdmin } from "../../util";

@Component({
    components: {
        DatePicker
    }
})
export default class LeaderBoard extends Vue {

    itemsPerPage = 10;
    pageIndex = 1;

    startDate: Date | undefined = undefined;
    endDate: Date | undefined = undefined;

    sortType: string = "reputation";
    reverse: boolean = false;

    pUsers: IUserSummary[] = [];

    currentUser: IOfferingUser | undefined = undefined;

    adminUser() {
        if (this.currentUser !== undefined) {
            return isAdmin(this.currentUser.roles);
        }
        return false;
    }

    updateCurrentUser(user: IOfferingUser) {
        this.currentUser = user;
    }

    updateUsers(newUsers: IUserSummary[]) {
        this.pUsers = newUsers;
        this.$emit("userData", newUsers);
    };

    @Lifecycle
    created() {
        Fetcher.get(UserService.getMostReputableUsers, {
            sortField: "userRating",
            sortOrder: "DESC"
        }).on(this.updateUsers);
        Fetcher.get(UserService.getLoggedInUser).on(this.updateCurrentUser);
    }

    @Lifecycle
    destroyed() {
        Fetcher.get(UserService.getMostReputableUsers).off(this.updateUsers);
    }

    updateShowItems(pageIndo: { size: number, page: number}) {
        this.itemsPerPage = pageIndo.size;
        this.pageIndex = pageIndo.page;
    }

    sort(item: { name: string, type: "DESC" | "ASC" }) {
        let sortOrder: "DESC" | "ASC" = "DESC";
        if (this.adminUser()) {
            sortOrder = item.type.toUpperCase() as "DESC" | "ASC";
        }
        
        UserService.getMostReputableUsers({
            sortField: item.name,
            sortOrder: sortOrder
        }).then(this.updateUsers);
    }

    get users() {
        return this.pUsers;
    }

    get pagedUsers() {
        if (this.users !== undefined && this.currentUser !== undefined) {
            const users = this.users.slice(0 + this.itemsPerPage * (this.pageIndex - 1),
                (this.itemsPerPage * this.pageIndex));
            const ownUserIndex = users.findIndex(x => x.id == this.currentUser!.id);
            const ownUser = this.users.find(x => x.id == this.currentUser!.id);
            if (ownUserIndex === -1 && ownUser !== undefined && ownUser.rank! < users[0].rank! ) {
                users.unshift(ownUser);
            } else if (ownUserIndex === -1 && ownUser !== undefined) {
                const joinedUsers = users.concat(ownUser);
                return joinedUsers;
            }
            return users;
        }
    }

    //TODO Handle if end Date is smaller than start
    @Watch("startDate")
    handleStartDate(_newDate: Date, _oldDate: Date) {
        if (_oldDate === undefined || (_newDate.getTime() != _oldDate.getTime())) {
            UserService.getMostReputableUsers({
                sortField: "userRating",
                sortOrder: "DESC",
                leaderboardStartDate: this.startDate,
                leaderboardEndDate: this.endDate
            }).then((results: IUserSummary[]) => this.updateUsers(results));
        }
    }

    @Watch("endDate")
    handleEndDate(_newDate: Date, _oldDate: Date) {
        if (_oldDate === undefined || (_newDate.getTime() != _oldDate.getTime())) {
            UserService.getMostReputableUsers({
                sortField: "userRating",
                sortOrder: "DESC",
                leaderboardStartDate: this.startDate,
                leaderboardEndDate: this.endDate
            }).then((results: IUserSummary[]) => this.updateUsers(results));
        }
    }

    get startingDate() {
        if (this.startDate === undefined) {
            return "";
        } else {
            return this.startDate.getFullYear() + "-" + ("0" + (this.startDate.getMonth() + 1)).slice(-2) + "-"
                + ("0" + this.startDate.getDate()).slice(-2);
        }
    }

    get endingDate() {
        if (this.endDate === undefined) {
            return "";
        } else {
            return this.endDate.getFullYear() + "-" + ("0" + (this.endDate.getMonth() + 1)).slice(-2) + "-"
                + ("0" + this.endDate.getDate()).slice(-2);
        }
    }

    set startingDate(newDateStr: string) {
        if (newDateStr === undefined || newDateStr == "") {
            this.startDate = undefined;
        } else {
            let newDate = new Date(newDateStr);
            this.startDate = newDate;
        }
    }

    set endingDate(newDateStr: string) {
        if (newDateStr === undefined || newDateStr == "") {
            this.endDate = undefined;
        } else {
            let newDate = new Date(newDateStr);
            this.endDate = newDate;
        }
    }

    redirectProfile(userID: number) {
        return { name: "profiles",
            query: {
                loadUserID: userID.toString()
            }
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/leaderboard/LeaderBoard.vue